import { Group, Pill } from "@mantine/core";

interface Props {
  name: string;
  value?: boolean;
}

const BooleanFilter = ({ name, value }: Props) => {
  if (value == null) return null;

  return (
    <Group gap="0">
      <Pill>{name}</Pill>
      <Pill>=</Pill>
      <Pill>{String(value)}</Pill>
    </Group>
  );
};

export default BooleanFilter;
